module.exports = __webpack_public_path__ + "assets/img/ac98e16d336e9d2404c37da899a6c13c.png";